import { render, staticRenderFns } from "./personInfoCollect.vue?vue&type=template&id=d869e892&scoped=true&"
import script from "./personInfoCollect.vue?vue&type=script&lang=js&"
export * from "./personInfoCollect.vue?vue&type=script&lang=js&"
import style0 from "./personInfoCollect.vue?vue&type=style&index=0&id=d869e892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d869e892",
  null
  
)

export default component.exports